import { Image1, Image2, Image3 } from '../../assets'
import {noProfile} from "../../assets"


export const Data = [
    {
      id: 1,
      image: noProfile,
      title: "Ndubuisi David",
      description:
        "A really good job, all aspects of the project were followed step by step and with good results.",
    },
    {
      id: 2,
      image: noProfile,
      title: "Peter Okezie",
      description:
        "I am truly impressed with the expert guidance and training provided by this web development consultant - they helped me take my web development skills to the next level!",
    },
    {
      id: 3,
      image: noProfile,
      title: "Sara Cill",
      description:
        "The website you created for me is simply fantastic!",
    },
    {
        id: 4,
        image: noProfile,
        title: "Developer's Court",
        description:
          "Exceptional web development! My site was upgraded flawlessly with top-notch MERN stack expertise and SEO optimizations!",
      },
  ];